export default function ( args ) {
    return Array.prototype.slice.call( null, args );
}
